import RootState from 'typings/RootState'
import { Event } from 'Store/common/common.types'
import { ListData, ReturnData } from './types'

export const selectReturnListEvent = (state: RootState): Event => state.returnOrderReducer.listEvent

export const selectReturnList = (state: RootState): ListData => state.returnOrderReducer.list

export const selectReturnActionEvent = (state: RootState): Event => state.returnOrderReducer.actionEvent

export const selectReturnDetail = (state: RootState): ReturnData | undefined =>
  state.returnOrderReducer.detail

export const selectReturnDetailEvent = (state: RootState): Event => state.returnOrderReducer.detailEvent
